import { PdfGen } from '../pdf/pdf';
import { OptsList } from './optsList';

export const ILayoutListSymbol = Symbol('LayoutList');

export interface ILayoutListGen {
  generate(pdf: PdfGen, opts: OptsList): Promise<void>;
}
